import { Product } from "@/types/product";
import { TableProps } from "antd";
import i18next from "i18next";
import SText from "@/styles/SText";

export const getProductColumns = (): TableProps<Product>["columns"] =>  {
  return [
    {
      title: i18next.t('product.code'),
      dataIndex: "code",
      key: "code",
    },
    {
      title: i18next.t('product.name'),
      dataIndex: "name",
      key: "name",
      render: name => <SText text={name} />
    },
    {
      title: i18next.t('product.brand1'),
      dataIndex: "model",
      key: "model1",
      width: 180,
      render: (model: string) => <SText text={model?.toLocaleUpperCase()} />
    },
    {
      title: i18next.t('product.brand2'),
      dataIndex: "t1",
      key: "t1",
      width: 180,
      render: (t1: string) => <SText text={t1?.toLocaleUpperCase()} />
    },
    {
      title: i18next.t('common.desc'),
      key: "desc",
      dataIndex: "desc",
      width: 100,
      render: (desc: string) => <SText text={desc} />
    },
    {
      width: 100,
      title: i18next.t('product.uom'),
      key: "uom",
      dataIndex: "uom",
      render: (prev, item) => item?.uom?.toLocaleUpperCase() ?? ''
    },
    {
      width: 120,
      title: `cbm(${i18next.t('product.cbm')})`,
      key: "cbm",
      dataIndex: "cbm",
    },
  ]
}

export const filterProductItemsByKeyword = <T extends { product?: Partial<Pick<Product, "code" | "name" | "model">> | null }>(
  items: T[], keyword: string,
): T[] => {
  const search = keyword.trim().toLowerCase();
  if (!search) return items;
  return items.filter(({ product }) =>
    [product?.code, product?.name, product?.model].some(value => value?.toLowerCase().includes(search)),
  );
};
